export default function CalendarSkeleton() {
  return (
    <section className="bg-background-global container mx-auto w-full animate-pulse">
      <div className="container mx-auto px-4">
        <div className="mx-auto mb-6 h-8 w-80 rounded bg-gray-200"></div>
        <div className="mx-auto mb-4 h-6 w-96 rounded bg-gray-200"></div>
        <div className="h-64 rounded-lg bg-gray-200"></div>
      </div>
    </section>
  );
}
